<button
  class="btn btn-raised btn-primary"
  type="button"
  (click)="launchChildSummary()"
>
  Open Summary
</button>
